var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypescript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 261,
    viewBox: "0 0 260 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_4705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.9996,
    y: 36.8906,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4996,
    y: 37.3906,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6562 76.4854H179.656V176.485H79.6562V76.4854Z",
    fill: "#017ACB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.672 113.517H132.469V121.798H119.5V158.642L119.156 158.735C118.688 158.86 112.516 158.86 111.188 158.72L110.125 158.626V121.798H97.1562V113.517L101.266 113.47C103.516 113.438 109.297 113.438 114.109 113.47C118.922 113.501 125.016 113.517 127.672 113.517V113.517ZM164.281 154.735C162.375 156.751 160.328 157.876 156.922 158.798C155.438 159.204 155.188 159.22 151.844 159.204C148.5 159.188 148.234 159.188 146.609 158.767C142.406 157.688 139.016 155.579 136.703 152.595C136.047 151.751 134.969 150.001 134.969 149.782C134.969 149.72 135.125 149.579 135.328 149.485C135.531 149.392 135.953 149.126 136.297 148.923C136.641 148.72 137.266 148.345 137.688 148.126C138.109 147.907 139.328 147.188 140.391 146.548C141.453 145.907 142.422 145.392 142.531 145.392C142.641 145.392 142.844 145.61 143 145.876C143.938 147.454 146.125 149.47 147.672 150.157C148.625 150.563 150.734 151.017 151.75 151.017C152.688 151.017 154.406 150.61 155.328 150.188C156.313 149.735 156.813 149.282 157.406 148.376C157.813 147.735 157.859 147.563 157.844 146.345C157.844 145.22 157.781 144.907 157.469 144.392C156.594 142.954 155.406 142.204 150.594 140.079C145.625 137.876 143.391 136.563 141.578 134.798C140.234 133.485 139.969 133.126 139.125 131.485C138.031 129.376 137.891 128.688 137.875 125.548C137.859 123.345 137.906 122.626 138.141 121.876C138.469 120.751 139.531 118.579 140.016 118.032C141.016 116.86 141.375 116.501 142.078 115.923C144.203 114.173 147.516 113.017 150.688 112.907C151.047 112.907 152.234 112.97 153.344 113.048C156.531 113.313 158.703 114.095 160.797 115.767C162.375 117.017 164.766 119.954 164.531 120.345C164.375 120.579 158.141 124.735 157.734 124.86C157.484 124.938 157.313 124.845 156.969 124.438C154.844 121.892 153.984 121.345 151.922 121.22C150.453 121.126 149.672 121.298 148.688 121.954C147.656 122.642 147.156 123.688 147.156 125.142C147.172 127.267 147.984 128.267 150.984 129.751C152.922 130.704 154.578 131.485 154.703 131.485C154.891 131.485 158.906 133.485 159.953 134.11C164.828 136.97 166.813 139.907 167.328 144.97C167.703 148.782 166.625 152.267 164.281 154.735V154.735Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_4705",
    x: -0.000366211,
    y: 0.890625,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_4705"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_4705",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.07f87f0e9d0db24535309af3b9cfd26c.svg";
export { ForwardRef as ReactComponent };